import { DIALOG_DATA, DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild, inject, signal } from '@angular/core';
import { DialogDirective } from './dialog.directive';
import { DialogProps, DialogService } from './dialog.service';
import { Divider } from '../divider/divider.component';
import { Icon } from '../icon/icon.component';
import { FADE_IN } from '../../animations/fade.animation';
@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, DialogDirective, DialogModule, Icon, Divider],
  templateUrl: './dialog.component.html',
  animations: [FADE_IN],
})
export class DialogComponent {
  @ViewChild(DialogDirective, { static: true }) dialogDirective:
    | DialogDirective
    | undefined;

  hasBackdrop = signal<boolean>(true);
  label = signal<string | undefined>(undefined);
  description = signal<string | undefined>(undefined);
  disableLayout = signal<boolean>(false);

  constructor(@Inject(DIALOG_DATA) private data: DialogProps) {}

  dialogService = inject(DialogService);

  ngOnInit() {
    if (this.dialogDirective) {
      const viewContainerRef = this.dialogDirective.viewContainerRef;
      const componentRef = viewContainerRef.createComponent(
        this.data.component,
      );

      if (this.data.componentProps) {
        Object.entries(this.data.componentProps).map(([key, value]) => {
          componentRef.setInput(key, value);
        });
      }
    }
    if (this.data.label) {
      this.label.set(this.data.label);
    }
    if (this.data.description) {
      this.description.set(this.data.description);
    }
    if (this.data.hasBackdrop === false) {
      this.hasBackdrop.set(false);
    }
    if (this.data.disableLayout === true) {
      this.disableLayout.set(true);
    }
  }
}
